
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme/ThemeContext";

interface EditChildDialogFooterProps {
  onCancel: () => void;
  onSave: () => void;
  isSubmitting: boolean;
  isDisabled: boolean;
}

export function EditChildDialogFooter({ 
  onCancel, 
  onSave, 
  isSubmitting, 
  isDisabled 
}: EditChildDialogFooterProps) {
  const isLightTheme = false;

  return (
    <div className="flex justify-end gap-3 mt-4">
      <Button 
        variant="outline" 
        onClick={onCancel}
        className={
          isLightTheme 
            ? "border-slate-300 bg-white hover:bg-slate-50" 
            : "border-slate-700 bg-transparent hover:bg-slate-800"
        }
      >
        Cancel
      </Button>
      <Button 
        onClick={onSave}
        disabled={isDisabled || isSubmitting}
        className={
          isLightTheme 
            ? "bg-blue-primary text-white hover:bg-blue-600" 
            : "bg-purple-600 hover:bg-purple-700"
        }
      >
        {isSubmitting ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  );
}
